import React from 'react';
import { createUseStyles } from 'react-jss';
import { Trans, useTranslation } from 'react-i18next';

import { Theme } from '@app/theme';
import { Button, PublicBackgroundBlock } from '@app/core';

const useStyles = createUseStyles((theme: Theme) => ({
  buttonsTitle: {
    ...theme.fonts.h4,
    color: theme.colors.inkPrimary,
  },
  editContainer: {
    padding: theme.marginBase * 4,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    flexWrap: 'wrap',
    [theme.media.mobile]: {
      padding: 0,
    },
  },
  editButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.marginBase * 2,
    [theme.media.mobile]: {
      width: '100%',
      gap: theme.marginBase,
      flexDirection: 'column',
    },
  },
  btnFlex: {
    [theme.media.mobile]: {
      width: '100%',
    },
  },
}));

interface Props {
  hidden?: boolean;
  isAbandoned?: boolean;
}

export const CancelParticipationBlock = ({ hidden, isAbandoned }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  if (hidden) {
    return null;
  }

  return (
    <PublicBackgroundBlock className={classes.editContainer}>
      <h2 className={classes.buttonsTitle}>
        {isAbandoned
          ? t('booked.summary.cancelButtonTitle')
          : t('booked.summary.rescheduleButtonsTitle')}
      </h2>
      <div className={classes.editButtonContainer}>
        {!isAbandoned && (
          <Button
            to="reschedule"
            color="blue"
            variant="muted"
            small
            className={classes.btnFlex}
          >
            <Trans i18nKey="booked.summary.reschedule" />
          </Button>
        )}
        <Button
          to={isAbandoned ? 'abandon' : 'cancel'}
          color="red"
          variant="muted"
          small
          className={classes.btnFlex}
        >
          <Trans
            i18nKey={
              isAbandoned ? 'booked.summary.abandon' : 'booked.summary.cancel'
            }
          />
        </Button>
      </div>
    </PublicBackgroundBlock>
  );
};
